import { z } from 'zod'

// Spec PWA-018 D-07 — resposta do botao "Transcrever". Indisponivel nao e erro da tela: e o estado daquele audio
// (mais de 1 minuto, formato do iPhone, limite do mes, falha — o botao volta).

export const sponsorTranscriptSchema = z.object({
    text: z.string().max(10_000),
    language: z.string().min(2).max(10),
}).strict()
export type SponsorTranscript = z.infer<typeof sponsorTranscriptSchema>

export const sponsorTranscriptionResultSchema = z.discriminatedUnion('status', [
    z.object({ status: z.literal('done'), text: z.string().max(10_000), language: z.string().min(2).max(10) }).strict(),
    z.object({ status: z.literal('unavailable'), reason: z.enum(['too_long', 'format', 'quota', 'failed']) }).strict(),
])
export type SponsorTranscriptionResult = z.infer<typeof sponsorTranscriptionResultSchema>
